import { NumberRange } from 'util/number/number-in-range'
import { getProcedimentosConsideradosTooltipText } from 'view/acompanhamento/acompanhamento-condicao-saude/utils-acompanhamentoCondicaoSaude'

const title = {
  plural: 'Exames considerados',
  singular: 'Exame considerado',
}

export const EXAMES_CANCER_MAMA_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText(
  ['Mamografia bilateral para rastreamento (0204030188)'],
  title
)

export const EXAMES_CANCER_COLO_UTERO_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText(
  [
    'Exame citopatológico cérvico vaginal/microflora-rastreamento (0203010086)',
    'Exame citopatológico cérvico-vaginal/microflora (0203010019)',
    'Coleta de material do colo do útero para exame molecular de detecção de HPV (0201020076)',
    'Entrega de material obtido por auto coleta para exame molecular para detecção de HPV, no colo do útero (0201020084)',
    'Coleta de material do colo de útero para exame citopatológico (0201020033)',
  ],
  title
)

export const RANGE_IDADE_RASTREIO_CANCER_COLO_UTERO: NumberRange = {
  min: 25,
  max: 64,
}

export const RANGE_IDADE_RASTREIO_CANCER_MAMA: NumberRange = {
  min: 50,
  max: 69,
}

export const RANGE_IDADE_RASTREIO_SAUDE_SEXUAL_REPRODUTIVA: NumberRange = {
  min: 14,
  max: 69,
}
